<template>
  <div class="flex flex-col bg-white border-b border-grey-light px-4-x py-2-x">
    <div class="flex justify-between items-center">
      <!-- left -->
      <div class="flex items-center space-x-2">

        <div v-if="_Allowed('show_layer_selector') && !designMode"
          class="flex items-center space-x-2 px-3 py-1.5 cursor-pointer
             text-grey-darkest hover:bg-grey-lighter hover:text-black
             transition-all duration-150 ease-out">
          <b-dropdown aria-role="list">
            <template #trigger>
              <p role="button" class="flex items-center space-x-1">
                <b-icon icon="solar-panel" pack="fas" size="is-small"></b-icon>
                <span class="text-xs font-semibold">{{ $t(currentView) }}</span>
                <b-icon icon="chevron-down" pack="fas" size="is-small"></b-icon>
              </p>
            </template>
            <b-dropdown-item aria-role="listitem"
              @click="() => { currentView='pilings'; $emit('epc-open-panel', 'view-pilings') }">
              <b-icon icon="band-aid" pack="fas" size="is-small"></b-icon> {{ $t('pilings') }}
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem"
              @click="() => { currentView='structures'; $emit('epc-open-panel', 'view-structures') }">
              <b-icon icon="stream" pack="fas" size="is-small"></b-icon> {{ $t('structures') }}
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem"
              @click="() => { currentView='modules'; $emit('epc-open-panel', 'view-modules') }">
              <b-icon icon="solar-panel" pack="fas" size="is-small"></b-icon> {{ $t('modules') }}
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <div v-if="_Allowed('show_areas') && currentView==='structures'"
          class="flex items-center space-x-2 px-3 py-1.5 cursor-pointer
               transition-all duration-150 ease-out"
          :class="showAreas
            ? 'bg-blue text-white hover:bg-blue-dark'
            : 'text-grey-darkest hover:bg-grey-lighter hover:text-black'"
          @click="() => { $emit('epc-open-panel', 'view-areas') }">
          <b-icon icon="eye" pack="fas" size="is-small"></b-icon>
          <span class="text-xs font-semibold">{{ $t('show_areas') }}</span>
        </div>

        <div v-if="_Allowed('show_insert') && designMode"
          class="flex items-center space-x-2 px-3 py-1.5 cursor-pointer
               text-grey-darkest hover:bg-grey-lighter hover:text-black
               transition-all duration-150 ease-out">
          <b-dropdown aria-role="list">
            <template #trigger>
              <p role="button" class="flex items-center space-x-1">
                <b-icon icon="plus" pack="fas" size="is-small"></b-icon>
                <span class="text-xs font-semibold">{{ $t('insert') }}</span>
                <b-icon icon="chevron-down" pack="fas" size="is-small"></b-icon>
              </p>
            </template>
            <b-dropdown-item aria-role="listitem"
              @click="() => { $emit('epc-open-panel', 'panel-views') }">
              <b-icon icon="solar-panel" pack="fas" size="is-small"></b-icon> {{ $t('pictograms') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="currentView==='structures' && showAreas"
              aria-role="listitem"
              @click="() => { $emit('epc-open-panel', 'panel-drawing') }">
              <b-icon icon="pen-nib" pack="fas" size="is-small"></b-icon> Vector
            </b-dropdown-item>
            <b-dropdown-item v-if="currentView==='structures' && showAreas"
              aria-role="listitem"
              @click="() => { $emit('epc-open-panel', 'tool-pencil') }">
              <b-icon icon="font" pack="fas" size="is-small"></b-icon> {{ $t('text') }}
            </b-dropdown-item>
          </b-dropdown>
        </div>

      </div>

      <!-- right -->
      <div class="flex items-center space-x-2">

        <div v-if="_Allowed('show_screenshot') && !designMode"
          class="flex items-center space-x-2 px-3 py-1.5 cursor-pointer
             text-grey-darkest hover:bg-grey-lighter hover:text-black
             transition-all duration-150 ease-out"
          data-action="screenshot"
          @click="() => { $emit('epc-click-screenshot') }">
          <b-icon size="is-small" icon="camera" pack="fas"></b-icon>
          <span class="text-xs font-semibold">{{ $t('screenshot') }}</span>
        </div>

        <div v-if="_Allowed('show_design_mode')"
          class="flex items-center space-x-2 px-3 py-1.5 cursor-pointer
             transition-all duration-150 ease-out"
          :class="designMode
            ? 'bg-blue text-white hover:bg-blue-dark'
            : 'text-grey-darkest hover:bg-grey-lighter hover:text-black'"
          @click="() => { designMode = !designMode; $emit('epc-in-design-mode', designMode) }">
          <b-icon icon="object-ungroup" pack="fas" size="is-small"></b-icon>
          <span class="text-xs font-semibold">{{ $t('design_mode') }}</span>
        </div>

        <div v-if="_Allowed('show_back')"
          class="flex items-center space-x-2 px-3 py-1.5 cursor-pointer
             text-grey-darkest hover:bg-grey-lighter hover:text-black
             transition-all duration-150 ease-out"
          @click="() => { $emit('epc-click-return') }">
          <b-icon size="is-small" icon="rotate-left" pack="fas"></b-icon>
          <span class="text-xs font-semibold">{{ $t('back') }}</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ViewerHeaderDesign",

    props: {
      showAreas: { type: Boolean, default: false },
      pictogramType: { type: String, default: 'structures' },
      canActions: { type: Object, default() { return {} } },
    },

    data() {
      return {
        designMode: false,
        currentView: this.pictogramType
      }
    },

    methods: {
      _Allowed(action) {
        // Si no se define la acción, se muestra por defecto (true)
        if (this.canActions[action] === undefined) return true
        return !!this.canActions[action]
      }
    }
  }
</script>

<style scoped>
</style>
